module.exports = __webpack_public_path__ + "static/media/text_icon.169c0619.svg";